export enum DrawingTools {
  paint = 'paint',
  draw = 'draw',
  erase = 'erase',
  zoomIn = 'zoomIn',
  zoomOut = 'zoomOut',
  none = '',
}

export enum DrawingColors {
  black = '#000000',
  red = '#ff0303',
  blue = '#2474F5',
  orange = '#F05C00',
  darkGreen = '#008A00',
  yellow = '#FFCF01',
  white = '#FFF'
}

export class PaletteColor {
  color: DrawingColors;
  name: string;
}

export enum DrawingBrushSizes {
  xs = 2,
  sm = 4,
  med = 8,
  lg = 16,
  xl = 24,
  xxl = 28
}

export enum DrawingBrushIconSizes {
  xs = '10px',
  sm = '14px',
  med = '18px',
  lg = '22px',
  xl = '26px',
  xxl = '30px',
}

export class DrawingBrushOption {
  size: DrawingBrushSizes;
  name: string;
  fontSize: string;
}

export class DrawingPage {
  clickX: number[] = [];
  clickY: number[] = [];
  clickDrag = [];
  clickColor: DrawingColors[] = [];
  clickSize: number[] = [];
  clickErase: boolean[] = [];
}

export class DrawingVectors {
  InitWidth: number;
  InitHeight: number;
  Zoom: number;
}
